import { useState } from "react";
import usePlanesStore from "../stores/usePlanesStore";

export const usePlanesValidacion = () => {
  const [validando, setValidando] = useState(false);
  const {
    fetchLimitesParaAccion,
    puedeCrearEvento,
    limites,
  } = usePlanesStore();

  const validarCrearEvento = async () => {
    setValidando(true);

    try {
      // antes de validar refrescamos los limites
      await fetchLimitesParaAccion();

      const puede = puedeCrearEvento();

      if (!puede) {
        const limitesEventos = usePlanesStore.getState().getLimitesEventos();
        return {
          valido: false,
          mensaje: limitesEventos?.esIlimitado
            ? "Error al verificar límites"
            : `Has alcanzado el límite de ${limitesEventos?.limite} eventos activos de tu plan. Contacta a soporte para ampliarlo.`,
        };
      }

      return { valido: true, mensaje: "" };
    } catch (error) {
      console.error("Error al validar límites:", error);
      return { valido: true, mensaje: "" };
    } finally {
      setValidando(false);
    }
  };

  const validarCrearTickets = async () => {
    return { valido: true, mensaje: "" };
  };

  return {
    validarCrearEvento,
    validarCrearTickets,
    validando,
    limites,
  };
};
